import axios from 'axios';
import { store } from '../redux/stores';
import AuthTypes from '../redux/constants';
import { API_DOMAIN } from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const errorHandler = (error) => {
    console.log(error)
    if (error.response){
        return {
            type: "response",
            error: error.response
        }
    }else if (error.request){
        return {
            type: "request",
            error: error.request
        }
    }else{
        return {
            type: "unknown",
            error: error.message
        }
    }
}

export default () =>{

    const API = axios.create({
        baseURL: `${API_DOMAIN}/apiv1-hb`,
        timeout: 20000,
        headers: {
            'accept': 'application/json', 
            'Content-Type': 'application/json',
            //'Access-Control-Allow-Origin': '*',
            'withCredentials': false,
        }
    })
    API.interceptors.request.use(function (request) {
        const authState = store.getState().auth;
        if (authState.isAuthenticated && authState.user.token !== ""){
            request.headers.Authorization = `Bearer ${authState.user.token}`;
        }
        return request;
    });

    API.interceptors.response.use(function (response) {
        return response;
      }, function (error) {
        const authState = store.getState().auth;
        //const navigate = useNavigate();
        //const dispatch = useDispatch();
        if (authState.isAuthenticated && authState.user.token !== ""){
            if (error.response.status == 401) {
                store.dispatch({
                    type: AuthTypes.LOGOUT,
                });
            }  
        }
        return Promise.reject(error);
      });
    return {
        post: async (path, payload, params = {}) => {
            try{
                return await API.post(path, payload, params);
            }catch(e){
                return {
                    data: errorHandler(e),
                    error: true
                }
            }
            
        },

        put: async (path, payload) => {
            try{
                return await API.put(path, payload);
            }catch(e){
                return {
                    data: errorHandler(e),
                    error: true
                }
            }
            
        },
        get: async (path, params = {}) => {
            try{
                return await API.get(path, params);
            }catch(e){
                return {
                    data: errorHandler(e),
                    error: true
                }
            }
        },

        delete: async (path, params = {}) => {
            try{
                return await API.delete(path);
            }catch(e){
                return {
                    data: errorHandler(e),
                    error: true
                }
            }
        }
    }
}
